import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app.jsx';
import 'normalize.css';
import { store as hushStore } from './services/hush.h';
import { app } from './constants';

hushStore(btoa([app.versionExtended, app.country].join('')));

const root = ReactDOM.createRoot(document.getElementById('app'));
root.render(<App />);
